import { EmptyState } from '../../components/ui/EmptyState';

// Single dev-placeholder for all screens that haven't been implemented yet.
// Agents 04+ replace route targets with real screens as milestones complete.
export default function Placeholder({ name }) {
  return (
    <div className="lk-page" data-placeholder={name}>
      <EmptyState
        title={`${name} — скоро`}
        desc="Экран будет реализован в следующем milestone."
      />
    </div>
  );
}
